import angular from 'angular'
import template from './template.html'
import { orderBy } from 'lodash'

export default class NominasNominaColaboradoresListaComponent {
  constructor () {
    this.idEmpresa = null
    this.idNomina = null
    this.data = []
    this.calculado = false
    this.editable = false
    this.onChange = null
    this.filtro = ''
    this.modalidades = []
  }

  $onChanges (changes) {
    if (changes.data) {
      this.data = orderBy(this.data, ['empleado'])

      this.remunerados = this.data.filter((item) => !item.cobro_carga_social)
      this.noremunerados = this.data.filter((item) => item.cobro_carga_social)

      this.modalidades = []

      if (this.remunerados.length) {
        this.modalidades.push({id: 1, descripcion: 'Remunerados'})
      }

      if (this.noremunerados.length) {
        this.modalidades.push({id: 2, descripcion: 'No remunerados'})
      }

      this.modalidad = this.modalidades[0] && this.modalidades[0].id
    }
  }

  editar (data) {
    this.remunerados = data
    this.noremunerados = []
    this.actualizar()
  }

  actualizar () {
    this.onChange({$event: {data: this.remunerados}})
  }
}

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresLista', {
    controller: NominasNominaColaboradoresListaComponent,
    template,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      data: '<',
      calculado: '<',
      editable: '<',
      onChange: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/lista/component.js